/**
 * MatrixGrid — renders an N×N grid with a missing cell.
 *
 * data: {
 *   grid: ["△", "○", "□", "○", "□", "△", "□", "?", "○"],
 *   cols: 3
 * }
 *
 * grid: flat array of cell values, read left-to-right, top-to-bottom.
 * cols: number of columns (default 3).
 * "?" renders as a mystery cell.
 */

export default function MatrixGrid({ data }) {
    const grid = data?.grid;
    const cols = data?.cols || 3;
    if (!Array.isArray(grid) || grid.length === 0) return null;

    return (
        <div
            className="qv-matrix"
            style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}
        >
            {grid.map((cell, i) => {
                const isMystery = cell === '?';
                return (
                    <div key={i} className={`qv-matrix__cell ${isMystery ? 'qv-matrix__cell--mystery' : ''}`}>
                        <span>{cell}</span>
                    </div>
                );
            })}
        </div>
    );
}
